import moment from 'moment'
import { DateRangePicker } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'
import { requestArgsDateRange } from './columnsReqArgs'

export class TransfusionsBeginOnColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.TRANSFUSIONS_BEGIN_ON

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Дата начала последнего переливания крови',
        component: DateRangePicker,
        defaultValue: [null, null],
        props: {
          allowClear: true,
          allDay: true,
          allowEmpty: [true, true],
          disabledDate: currentDate => currentDate && currentDate.isAfter(moment()),
        },
      },
      width: 250,
      dataIndex: 'transfusions_begin_on',
      dataRender: transfusions_begin_on => transfusions_begin_on ? moment(transfusions_begin_on).format('DD.MM.YYYY') : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs = reqArgs => requestArgsDateRange(this.type, reqArgs)
}
